import { IndexActionComponentMainDiv } from "../../styles/indexcomponentsstyles/indexactioncomponentstyles";
import { ReactComponent as Icon } from "./assets/brain-solid-full.svg";
const IndexActionComponent = () => {
  return (
    <IndexActionComponentMainDiv>
      <div>
        {data.map((item, index) => (
          <div key={index +"action items"} className="index-action-card-container">
            <div>
              <div className="index-action-card-icon">
                <Icon />
              </div>
              <div className="index-action-card-skeleton-holder">
                <div>
                  <div className="index-action-card-text">
                    <h3> name </h3>
                  </div>
                </div>
                <div className="index-action-card-skeleton">
                  <div> </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </IndexActionComponentMainDiv>
  );
};
const data = ["d", "d", "d", "d"];
export default IndexActionComponent;
